<div class="tree-node" [style.margin-left.px]="level * 20">
  <div class="node-content" (click)="onNodeClick()">
    @if (node.nodes && node.nodes.length > 0) {
      <span
        class="toggle-icon"
        (click)="toggleExpanded($event)">
        {{ node.state.expanded ? '▼' : '▶' }}
      </span>
    }
    <input type="checkbox"
      [checked]="node.state.checked"
      (change)="onCheckboxChange($event)"
      (click)="$event.stopPropagation()">
      <span class="node-text">{{ node.text }}</span>
      @if (node.tags && node.tags.length > 0) {
        <span class="node-tags">
          ({{ node.tags[0] }})
        </span>
      }
    </div>

    @if (node.nodes && node.nodes.length > 0 && node.state.expanded) {
      <div
        class="child-nodes">
        @for (childNode of node.nodes; track trackByNodeId($index, childNode)) {
          <app-tree-node
            [node]="childNode"
            [level]="level + 1"
            (nodeSelected)="nodeSelected.emit($event)"
            (nodeChecked)="nodeChecked.emit($event)"
            (nodeUnchecked)="nodeUnchecked.emit($event)">
          </app-tree-node>
        }
      </div>
    }
  </div>
